"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorMessage = exports.ErrorMessageProvider = void 0;
var ErrorMessageProvider_1 = require("./ErrorMessageProvider");
Object.defineProperty(exports, "ErrorMessageProvider", { enumerable: true, get: function () { return __importDefault(ErrorMessageProvider_1).default; } });
Object.defineProperty(exports, "useErrorMessage", { enumerable: true, get: function () { return ErrorMessageProvider_1.useErrorMessage; } });
//# sourceMappingURL=index.js.map